import styled from 'styled-components';

const ModalForm = styled.form`
  position: absolute;
  top: 50%;
  left: 50%;
  width: min(700px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 40px 40px 40px 0;
  background-color: #fff;
  outline: none;
`;

const ScrollArea = styled.div`
  box-sizing: border-box;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 25px;
  scrollbar-gutter: stable;
`;

const ModalTitle = styled.div`
  margin-bottom: 10px;
  color: ${(p) => p.theme.colors.gray500};
  font-size: ${(p) => p.theme.fontSizes.md};
  font-weight: 700;
`;

const TextUnderline = styled.div`
  overflow-wrap: anywhere;
  color: ${(p) => p.theme.colors.primary500};
  font-size: ${(p) => p.theme.fontSizes.base};
  text-decoration: underline;
`;

const LinkButton = styled.button`
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${(p) => p.theme.colors.primary500};
  cursor: pointer;
  font: inherit;
  text-decoration: underline;
`;

const ListData = styled.ul`
  margin: 0;
  padding: 0;
  border-top: 1px solid ${(p) => p.theme.colors.gray200};
  list-style: none;

  li {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(220px, 1.4fr) auto;
    gap: 15px;
    align-items: center;
    min-height: 46px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray200};

    > div:first-child,
    > div:nth-child(2) {
      min-width: 0;
      overflow: hidden;
      color: ${(p) => p.theme.colors.gray500};
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > div:nth-child(2) {
      color: ${(p) => p.theme.colors.gray300};
    }

    &.empty {
      display: block;
      box-sizing: border-box;
      padding: 12px 0;
      color: ${(p) => p.theme.colors.gray300};
    }

    .action {
      display: flex;
      align-items: center;
      gap: 10px;

      button {
        display: inline-flex;
        padding: 4px;
        border: 0;
        background: transparent;
        cursor: pointer;
      }
    }
  }

  @media (max-width: 640px) {
    li {
      grid-template-columns: minmax(0, 1fr) auto;

      > div:nth-child(2) {
        grid-column: 1 / -1;
        padding: 0 10px 10px 42px;
      }
    }
  }
`;

const ErrorText = styled.div`
  color: ${(p) => p.theme.colors.danger};
  font-size: ${(p) => p.theme.fontSizes.sm};
`;

const OrderList = styled.ol`
  margin: 0;
  padding: 0;
  border-top: 1px solid ${(p) => p.theme.colors.gray200};
  list-style: none;

  li {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr) auto;
    gap: 12px;
    align-items: center;
    min-height: 46px;
    border-bottom: 1px solid ${(p) => p.theme.colors.gray200};
  }

  li > span:nth-child(2) {
    min-width: 0;
    overflow-wrap: anywhere;
  }

  li > div {
    display: flex;
    gap: 4px;
  }
`;

const OrderButton = styled.button<{ $direction: 'up' | 'down' }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid ${(p) => p.theme.colors.gray200};
  border-radius: ${(p) => p.theme.radii.base};
  background: #fff;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
    transform: rotate(${(p) => p.$direction === 'up' ? '-90deg' : '90deg'});
  }

  &:disabled {
    cursor: default;
    opacity: 0.4;
  }
`;

const ModalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;
  margin-top: 40px;

  > button {
    min-width: 0;
  }

  @media (max-width: 520px) {
    gap: 20px;

    > button {
      width: calc(50% - 10px);
    }
  }
`;

export {
  ErrorText,
  LinkButton,
  ListData,
  ModalActions,
  ModalForm,
  ModalTitle,
  OrderButton,
  OrderList,
  ScrollArea,
  TextUnderline,
};
